var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2767 14.3416C1.31307 14.0142 1.33126 13.8505 1.38079 13.6976C1.42472 13.5618 1.4868 13.4327 1.56534 13.3136C1.65386 13.1793 1.77031 13.0629 2.00321 12.83L12.4582 2.37501C13.3326 1.50056 14.7504 1.50057 15.6249 2.37502C16.4993 3.24947 16.4993 4.66723 15.6249 5.54168L5.16987 15.9967C4.93698 16.2295 4.82053 16.346 4.68629 16.4345C4.56719 16.513 4.43803 16.5751 4.3023 16.6191C4.14931 16.6686 3.98564 16.6868 3.65829 16.7232L0.979004 17.0208L1.2767 14.3416Z",
    stroke: "#0092DD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditActive);
export default __webpack_public_path__ + "static/media/edit_active.491b7f8745957e2a3c8fbf02004d60e8.svg";
export { ForwardRef as ReactComponent };